import { Actions } from '../../interfaces'
import { Platform } from '@/entities/public'

import find from './find'

export const actions: Actions = {
  find,
}

export default {
  Model: { Platform },
  actions: { [Platform.name]: actions },
}
